export default "__VITE_ASSET__CbKoXJ2V__"